export { US_STATES, CA_PROVINCES } from "shared-ts/libs/country"

// prefix & suffix for barcode scanning
export const SCAN_PREFIX_SUFFIX = "|"

// Max length for product identifiers
export const MAX_IDENTIFIER_CHARACTERS = 80

export function supportNumber(format: "display" | "E.164" = "display"): string {
  if (format === "E.164") {
    return "+16503343205"
  }
  return "(650) 334-3205"
}

export const EXCEL_EXTENSION = ".xlsx"

export const SEARCH_INPUT_FILTERS_MIN_LENGTH = 3
